import React, {useEffect} from "react";
import {
    InstantSearch,
    SearchBox,
    Hits,
    RefinementList,
    Pagination,
    InfiniteHits,
    CurrentRefinements,
    connectHits,
    SortBy,
    Configure
} from 'react-instantsearch-dom';
import AlgoliaClient, { IssueIndex } from '../../services/Algolia';

import IssueTable from './IssueTable';
import IconButton from "material-ui/IconButton";
import FilterIcon from "material-ui/svg-icons/content/filter-list";
import RefreshIcon from "material-ui/svg-icons/navigation/refresh";


const isTrueSet = (val) => (val === 'true');

class IssuesView extends React.Component {

    state = {
        searchState: {
            query: '',
            refinementList: {
                projectId: ['-MD94ehS3GeuBx65Iec1'],
            }
        },
        refresh: false,
        isFiltersOpen: isTrueSet(localStorage.getItem('pulser-ui-isFiltersOpen')) || false
    };

    onSearchStateChange = (state) => {
        const newState = {...state};

        this.setState({searchState: newState});
    };

    refresh = () => {
        this.setState({ refresh: true }, () => {
            this.setState({ refresh: false });
        });
    };

    toggleFilterBar = () => {
        const { isFiltersOpen } = this.state;

        const flag = !isFiltersOpen;

        this.setState({isFiltersOpen: flag }, () => {
            localStorage.setItem('pulser-ui-isFiltersOpen', `${flag}`);
        })
    };

    renderFilters = () => {
        const { isFiltersOpen } = this.state;

        if (!isFiltersOpen) {
            return null;
        }

        return (
            <div className="issue-filter-panel" style={{overflow: 'scroll'}}>
                <div className="title-wrap">
                    <span className="title-wrap-text">Filter by</span>
                </div>
                <div style={{height: '100%'}}>
                    <FilterPanelItem
                        title="Checklist"
                        attribute="_checklistName"
                    />
                    <FilterPanelItem
                        title="Assign To"
                        attribute="_assignTo"
                    />
                    <FilterPanelItem
                        title="Issue Status"
                        attribute="_issueState"
                    />
                    <FilterPanelItem
                        title="Category"
                        attribute="category"
                    />
                    <FilterPanelItem
                        title="Floor"
                        attribute="location.floor.name"
                    />
                    <FilterPanelItem
                        title="Unit"
                        attribute="location.unit.name"
                    />
                </div>
            </div>
        )
    }

    render() {
        const { onRowClick, reportMode, selectedProjectId, fetchIssues, issues, issuesForReport, selectAllCheckBox, clearIssues, renderReportButtons } = this.props;
        const { searchState, refresh , isFiltersOpen} = this.state;

        if (!selectedProjectId) {
            return null;
        }

        return (
            <div style={{position: "relative"}}>
                {/*<InstantSearch searchClient={AlgoliaClient} indexName="issues" searchState={searchState} onSearchStateChange={this.onSearchStateChange}>*/}
                <InstantSearch searchClient={AlgoliaClient} indexName="issues" refresh={refresh}>
                    <Configure
                        filters={`projectId:'${selectedProjectId}'`}
                    />
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <IconButton
                            onClick={this.toggleFilterBar}
                            tooltipPosition="top-center"
                            tooltip="Open / Close filters"

                        >
                            <FilterIcon />
                        </IconButton>

                        <SearchBox />

                        <IconButton
                            onClick={this.refresh}
                            tooltipPosition="top-center"
                            tooltip="Refresh"
                        >
                            <RefreshIcon />
                        </IconButton>

                        <CurrentRefinements/>
                    </div>
                    {this.renderFilters()}
                    <div style={{float: 'right', width: isFiltersOpen ? '80%' : '100%'}}>
                        <IssueHits
                            fetchIssues={fetchIssues}
                            clearIssues={clearIssues}
                            onRowClick={onRowClick}
                            reportMode={reportMode}
                            issues={issues}
                            issuesForReport={issuesForReport}
                            selectAllCheckBox={selectAllCheckBox}
                        />

                        {renderReportButtons()}
                        <div className="pagination-wrapper">
                            <Pagination/>
                        </div>

                    </div>
                </InstantSearch>
            </div>
        );
    }
}

const FilterPanelItem = ({attribute, title}) => {
    return (
        <div className="issue-filter-panel-item">
            <span className="issue-filter-panel-item-title">{title}</span>
            <RefinementList attribute={attribute} limit={50}  />
        </div>
    )
}


const CustomHits = ({hits, onRowClick, reportMode, fetchIssues, clearIssues, issues, issuesForReport, selectAllCheckBox}) => {
    useEffect(() => {
        if (hits && hits.length) {
            console.log(hits);
            fetchIssues(hits);
        } else {
            clearIssues();
        }

    }, [hits]);

    const arrIssues = Object.values(issues).sort((a, b) => b.createdAt - a.createdAt);

    return (
        <IssueTable
            reportMode={reportMode}
            onRowClick={onRowClick}
            arrIssues={arrIssues}
            issuesForReport={issuesForReport}
            selectAllCheckBox={selectAllCheckBox}
            sort={{
                field: 'issueNumber',
                direction: 'desc' // asc desc
            }}
        />
    )
};

const IssueHits = connectHits(CustomHits);

export default IssuesView;